import { ShapesCollection } from "../ShapesCollection";

const colors = ["#FF9800", "#607D8B", "#00C7B5", "#03A9F4", "#9575CD", "#F06292"];

export function setHeaderColor(data: ShapesCollection): void {
	data.forEach(shape => {
		const kids = shape.$connection;
		if (kids) {
			const firstChildColor = data.getItem(kids[0][1]).headerColor;
			shape.$expandColor = firstChildColor || colors[(shape.$level + 1) % colors.length];
		}

		let headerColor = colors[shape.$level % colors.length];
		if (shape.partner) headerColor = colors[(shape.$level - 1) % colors.length];
		if (shape.assistant) headerColor = colors[(shape.$level + 2) % colors.length];

		shape.stroke = shape.stroke || headerColor;
		shape.headerColor = shape.headerColor || headerColor;
	});
}
